import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

interface NavbarProps {
  activeTab: 'about' | 'blog' | 'photography' | 'resume';
  setActiveTab: (tab: 'about' | 'blog' | 'photography' | 'resume') => void;
}

const Navbar: React.FC<NavbarProps> = ({ activeTab, setActiveTab }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const handleTabClick = (tab: 'about' | 'blog' | 'photography' | 'resume') => {
    setActiveTab(tab);
    setIsMobileMenuOpen(false); // Close mobile menu when tab is clicked
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" className="brand-link" onClick={() => setIsMobileMenuOpen(false)}>
            <h1>Sourov Roy</h1>
          </Link>
        </div>
        <div className="navbar-tabs">
          <Link
            to="/about"
            className={`navbar-tab ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => handleTabClick('about')}
          >
            About Me
          </Link>
          <Link
            to="/blog"
            className={`navbar-tab ${activeTab === 'blog' ? 'active' : ''}`}
            onClick={() => handleTabClick('blog')}
          >
            Blog
          </Link>
          <Link
            to="/photography"
            className={`navbar-tab ${activeTab === 'photography' ? 'active' : ''}`}
            onClick={() => handleTabClick('photography')}
          >
            Photography
          </Link>
          <Link
            to="/resume"
            className={`navbar-tab ${activeTab === 'resume' ? 'active' : ''}`}
            onClick={() => handleTabClick('resume')}
          >
            Resume
          </Link>
        </div>
        <div 
          className={`navbar-mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      {/* Mobile Menu */}
      <div 
        ref={mobileMenuRef}
        className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}
      >
        <Link
          to="/about"
          className={`mobile-menu-link ${activeTab === 'about' ? 'active' : ''}`}
          onClick={() => handleTabClick('about')}
        >
          About Me
        </Link>
        <Link
          to="/blog"
          className={`mobile-menu-link ${activeTab === 'blog' ? 'active' : ''}`}
          onClick={() => handleTabClick('blog')}
        >
          Blog
        </Link>
        <Link
          to="/photography"
          className={`mobile-menu-link ${activeTab === 'photography' ? 'active' : ''}`}
          onClick={() => handleTabClick('photography')}
        >
          Photography
        </Link>
        <Link
          to="/resume"
          className={`mobile-menu-link ${activeTab === 'resume' ? 'active' : ''}`}
          onClick={() => handleTabClick('resume')}
        >
          Resume
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
